import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as Authorization from '../../lib/authorization';
import * as AppState from '../../state/reducer/app/appState';

import Console from '../../lib/debug';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../lib/segment/SegmentService';

import AnalyticsNavIcon from './AnalyticsNavIcon';

const MAX_USER_ID_FOR_GYM_TOOLS = 2550000;

class SideNav extends Component {
    handleRedirect = (authorizationObject, newTab = false) => {
        const isAuthorized = authorizationObject.isAllowed();
        if (!isAuthorized) {
            return AppState.showUnauthorizedDialog();
        }

        const url = authorizationObject.path;
        if (newTab) {
            window.open(url);
        } else {
            window.location = url;
        }
    };

    openSupport = () => {
        window.zE.activate({ hideOnClose: true });
    };

    isCoachHome = () => location.pathname === '/';

    isAthleteTab = () => {
        return location.href.indexOf('/athlete/') > -1;
    };

    isTeamTab = () => {
        return location.href.indexOf('/team/') > -1;
    };

    isLibrary = () => {
        return (
            location.href.indexOf('/program/') > -1 ||
            location.href.indexOf('/calendar/') > -1
        );
    };

    isAnalytics = () => {
        return location.href.indexOf('/analytics') > -1;
    };

    isGymTools = () => {
        return location.href.indexOf('/gymtools') > -1;
    };

    render() {
        Console.render('SideNav');

        if (!this.props.loggedInUser) {
            return null;
        }
        const isGymToolsEnabled =
            this.props.loggedInUser.id < MAX_USER_ID_FOR_GYM_TOOLS;
        return (
            <div className="side-navbar">
                <div className="navbar-header">
                    <div className="th-brand">
                        <button
                            onClick={() => {
                                SegmentService.track(
                                    SEGMENT_EVENTS['ClickCTA'].key,
                                    {
                                        sources: 'Web app',
                                        ctaLocation: 'Lefthand Nav',
                                        ctaText: 'Coach Home'
                                    }
                                );
                                AppState.navigate('');
                            }}
                            className="th-nav"
                        >
                            <img
                                alt="Heroic-Logo"
                                src="https://static.trainheroic.com/images/h_white.png"
                            />
                        </button>
                    </div>
                </div>

                <div className="nav-container">
                    <div className="primary-nav">
                        <ul className="nav main-links">
                            <li
                                className={
                                    'nav-link' +
                                    (this.isCoachHome() ? ' nav-active' : '')
                                }
                            >
                                <button
                                    onClick={() => {
                                        SegmentService.track(
                                            SEGMENT_EVENTS['ClickCTA'].key,
                                            {
                                                sources: 'Web app',
                                                ctaLocation: 'Lefthand Nav',
                                                ctaText: 'Coach Home'
                                            }
                                        );
                                        AppState.navigate('');
                                    }}
                                    className="th-nav"
                                >
                                    <i className="mdi mdi-home" />
                                    <span className="nav-title">
                                        Coach <br /> Home
                                    </span>
                                </button>
                            </li>
                            <li
                                className={
                                    'nav-link' +
                                    (this.isAthleteTab() ? ' nav-active' : '')
                                }
                            >
                                <button
                                    onClick={() => {
                                        SegmentService.track(
                                            SEGMENT_EVENTS['ClickCTA'].key,
                                            {
                                                sources: 'Web app',
                                                ctaLocation: 'Lefthand Nav',
                                                ctaText: 'Athletes'
                                            }
                                        );
                                        this.handleRedirect(
                                            Authorization.navigateToAthletes
                                        );
                                    }}
                                    className="th-nav"
                                >
                                    <i className="mdi mdi-account" />
                                    <span className="nav-title">Athletes</span>
                                </button>
                            </li>

                            <li className="nav-link">
                                <button
                                    onClick={() => {
                                        SegmentService.track(
                                            SEGMENT_EVENTS['ClickCTA'].key,
                                            {
                                                sources: 'Web app',
                                                ctaLocation: 'Lefthand Nav',
                                                ctaText: 'Teams'
                                            }
                                        );
                                        this.handleRedirect(
                                            Authorization.navigateToTeams
                                        );
                                    }}
                                    className="th-nav"
                                >
                                    <i className="mdi mdi-account-multiple" />
                                    <span className="nav-title">Teams</span>
                                </button>
                            </li>

                            <li
                                className={
                                    'nav-link' +
                                    (this.isLibrary() ? ' nav-active' : '')
                                }
                            >
                                <button
                                    onClick={() => {
                                        SegmentService.track(
                                            SEGMENT_EVENTS['ClickCTA'].key,
                                            {
                                                sources: 'Web app',
                                                ctaLocation: 'Lefthand Nav',
                                                ctaText: 'Library'
                                            }
                                        );
                                        this.handleRedirect(
                                            Authorization.navigateToLibrary
                                        );
                                    }}
                                    className="th-nav"
                                >
                                    <i className="mdi mdi-folder" />
                                    <span className="nav-title">Library</span>
                                </button>
                            </li>

                            <li
                                className={
                                    'nav-link' +
                                    (this.isAnalytics() ? ' nav-active' : '')
                                }
                            >
                                <button
                                    onClick={() => {
                                        SegmentService.track(
                                            SEGMENT_EVENTS['ClickCTA'].key,
                                            {
                                                sources: 'Web app',
                                                ctaLocation: 'Lefthand Nav',
                                                ctaText: 'Analytics'
                                            }
                                        );
                                        AppState.navigate('/analytics');
                                    }}
                                    className="th-nav"
                                >
                                    <AnalyticsNavIcon />
                                    <span className="nav-title">Analytics</span>
                                </button>
                            </li>

                            {isGymToolsEnabled && (
                                <li
                                    className={
                                        'nav-link' +
                                        (this.isGymTools() ? ' nav-active' : '')
                                    }
                                >
                                    <button
                                        onClick={() => {
                                            SegmentService.track(
                                                SEGMENT_EVENTS['ClickCTA'].key,
                                                {
                                                    sources: 'Web app',
                                                    ctaLocation: 'Lefthand Nav',
                                                    ctaText: 'Gym Tools'
                                                }
                                            );
                                            AppState.navigate('/gymtools');
                                        }}
                                        className="th-nav"
                                    >
                                        <i className="mdi mdi-tablet-ipad" />
                                        <span className="nav-title">
                                            Gym <br /> Tools
                                        </span>
                                    </button>
                                </li>
                            )}
                        </ul>

                        <ul className="nav bottom-links">
                            <li className="nav-link">
                                <button
                                    onClick={() =>
                                        this.handleRedirect(
                                            Authorization.navigateToAthleteWeb,
                                            true
                                        )
                                    }
                                    className="th-nav nav-link-trainheroic"
                                >
                                    <i className="mdi mdi-autorenew" />
                                    <span className="nav-title">Switch</span>
                                </button>
                            </li>

                            <li className="nav-link">
                                <button
                                    onClick={() => this.openSupport()}
                                    className="support-link th-nav"
                                >
                                    <i className="mdi mdi-help-circle" />
                                    <span className="nav-title">Support</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        loggedInUser: state.app.loggedInUser
    };
};

export default connect(mapStateToProps)(SideNav);



// WEBPACK FOOTER //
// ./src/view/nav/SideNav.jsx